import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button, Fade } from "react-bootstrap";
import check from "../../../picture/check.png";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { saveAs } from "file-saver";
import { AiOutlineDownload } from "react-icons/ai";
import { GrSend } from "react-icons/gr";
import file1 from "../../../file/Announcement-of-the-Ministry-of-Transport-thai.pdf";
import file2 from "../../../file/Announcement-of-the-Ministry-of-Transport.pdf";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import Static_modal from "../etc/Static_modal";
import FadeIn from "react-fade-in/lib/FadeIn";
function RegisPilotSpacific() {
  let Navigate = useNavigate();

  const [data, setData] = useState("");
  const [show, setShow] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [updatedata, setUpdatedata] = useState(false);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [checklist, setchecklist] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [agree3, setAgree3] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [key, setKey] = useState("1");
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  function editdrone() {
    //setDisabless(false);
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  const retoken = () => {
    const check = AuthServiceV2.NewToken();
    if (check != null) {
      check.then((res) => {
        console.log(res);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
    }
  };
  const handleClose = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    setUpdatedatasuc(false);
    setcheckuserdata(false);
    setchecklist(false);
  };
  const handleSend = () => {
    setShow(true);
  };
  const handleSendsuc = () => {
    setShow(false);
    
    register("open");
    retoken();
    //register(false);
  };
  const handleUpdate = () => {
    setUpdatedata(true);
  };

  function scrollToElement(elem_id) {
    const element = document.getElementById(elem_id);
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const handleUpdatesuc = () => {
    
    console.log(agree1, agree2, agree3);
    scrollToElement('senddata') 
    if (agree1 === true && agree2 === true && agree3 === true) {
      setchecklist(false);
      //setUpdatedatasuc(true);
    } else {
    }

   //register(true);
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate("/home");
  };
  function edit() {
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  useEffect(() => {
    let checkoper = AuthServiceV2.checkpilot().then((res) => {
      //console.log(res);
      const data1 = AuthServiceV2.getCurrentUser().then(function (
        result
      ) {
        console.log("sdfgdfg")
        setData(result.data.data);
        //console.log(result);
        //setchecklist(true);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
      if (res.data.code === "OPEN" || res.data.code === "BOTH") {
        console.log("code200");
        setShowErroroperation(true);
        setTimeout(() => {
          Navigate("/home");
        }, 2000);
      } else {
        const check = AuthServiceV2.getCurrentUser();
        if (check != null)
          check.then(function (result) {
            if (result.data.data.address != null) {
              //console.log(result.data.code);
              const data1 = AuthServiceV2.getCurrentUser().then(function (
                result
              ) {
                setData(result.data.data);
                //console.log(result);
                setchecklist(true);
              }).catch((error)=>{
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });
        
              })
            } else {
              //console.log("passGDSNS");
              setcheckuserdata(true);
              setTimeout((e) => {
                setcheckuserdata(false);
                editdrone();
                //Navigate("/profile/editprofileuser");
              }, 2000);
              //console.log("passPNS");
              const data1 = AuthServiceV2.getCurrentUser().then(function (
                result
              ) {
                setData(result.data.data);
                //console.log(result)
              }).catch((error)=>{
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });
        
              })
            }
          }).catch((error)=>{
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
    
          })
      }
    }).catch((error)=>{
      setTextBody(error);
      setModalToggle({ ...modalToggle, modalErr: true });
      
      if(error === "กำลังอยู่ในสถานะ ยื่นคำขอ SPECIFIC"){
        setTimeout(() => {
          Navigate("/home");
        }, 2000);
      }
    })
  }, []);
  const register = (type) => {
    const check = AuthServiceV2.registerpilot(type);
    if (check != null)
      check.then((response) => {
        setSenddata(true);
        console.log(response);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
  };

  useEffect(() => {
    const tabContentElement = document.getElementById("key-tab-" + key);
    if (tabContentElement) {
      tabContentElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [key]);

  return (
    <div style={{ fontFamily: "Kanit" }}>
      <div>
        <h2
          style={{
            color: "#0077B6",
            height: "58px",
            fontSize: "39px",
            margin: "60px 0px 0px 90px",
          }}
        >
          ขอใบขึ้นทะเบียนนักบิน
        </h2>

        <Form noValidate >
          <div style={{ display: "flex" }}>
            <h3
              style={{
                color: "#0077B6",
                height: "58px",
                fontSize: "39px",
                margin: "60px 0px 0px 90px",
              }}
            >
              ข้อมูลผู้ขอขึ้นทะเบียน
            </h3>
            <Button
              onClick={edit}
              style={{
                background:
                  "linear-gradient(97.29deg, #FDC43F 0%, #FCEC5D 100%)",
                width: "125px",
                height: "49px",
                margin: "60px 0px 0px 50px",
                borderWidth: "0px",
                borderRadius: "79px",
                fontSize: "22px",
                color: "black",
              }}
            >
              แก้ไข
            </Button>
          </div>

          <Row
            className="mb-3"
            style={{
              padding: "0px 90px",
              width: "100%",
              margin: "30px auto ",
              fontSize: "28px",
            }}
          >
            <Form.Group as={Col} md="4" controlId="validationFormik03">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                คำนำหน้าชื่อ
              </Form.Label>
              <Form.Control
                classname="box"
                type="text"
                ////placeholder="นาย"
                name="title"
                value={data.title}
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
                disabled
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormik04">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                ชื่อ
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="First Name"
                name="firstName"
                value={data.f_name}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                นามสกุล
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="Last Name"
                name="lastName"
                value={data.l_name}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="12" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                เลขบัตรประชาชน
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="1-1234-12345-12-3"
                name="id"
                value={data.idnum}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                อีเมล
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="example@example.com"
                name="email"
                value={data.email}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                เบอร์โทรศัพท์
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="099-999-9999"
                name="tel"
                value={data.phone}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                เบอร์โทรศัพท์
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="อื่นๆ"
                value={data.occupation}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                วัน-เดือน-ปี เกิด
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="01/07/1998"
                name="date_of_birth"
                value={data.date_of_birth}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                อายุ
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="24"
                name="age"
                value={data.age}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                เชื้อชาติ
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="ไทย"
                name="ethnicity"
                value={data.nationality}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="validationFormik05">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                สัญชาติ
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="ไทย"
                name="nationality"
                value={data.nationality}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
          </Row>
          <h3
            style={{
              color: "#0077B6",
              height: "58px",
              fontSize: "39px",
              margin: "60px 0px 0px 90px",
            }}
          >
            ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
          </h3>
          <Row
            className="mb-3"
            style={{
              padding: "0px 90px",
              width: "100%",
              margin: "30px auto ",
              fontSize: "28px",
            }}
          >
            <Form.Group as={Col} md="6" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                ที่อยู่ (เลขที่,หมู่ที่,อาคาร,หมู่บ้าน,ซอย,ถนน)
              </Form.Label>

              <Form.Control
                type="text"
                ////placeholder="9/40 หมู่1 หมู่บ้านกรุงไทย"
                aria-describedby="inputGroupPrepend"
                name="oldadd"
                value={data.address}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                จังหวัด
              </Form.Label>
              <Form.Control
                type="text"
                ////placeholder="ระยอง"
                aria-describedby="inputGroupPrepend"
                name="oldprovince"
                value={data.province}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                ตำบล
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="เนินพระ"
                aria-describedby="inputGroupPrepend"
                name="olddist1"
                value={data.sub_dis}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                อำเภอ
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="เมืองระยอง"
                aria-describedby="inputGroupPrepend"
                name="olddist2"
                value={data.dis}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                รหัสไปรษณีย์
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="21000"
                aria-describedby="inputGroupPrepend"
                name="zip2"
                value={data.pos_code}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
          </Row>
          <h3
            style={{
              color: "#0077B6",
              height: "58px",
              fontSize: "39px",
              margin: "60px 0px 0px 90px",
            }}
          >
            ที่อยู่ปัจจุบัน
          </h3>
          <Row
            className="mb-3"
            style={{
              padding: "0px 90px",
              width: "100%",
              margin: "30px auto ",
              fontSize: "28px",
            }}
          >
            <Form.Group as={Col} md="6" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                ที่อยู่ (เลขที่,หมู่ที่,อาคาร,หมู่บ้าน,ซอย,ถนน)
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="9/40 หมู่1 หมู่บ้านกรุงไทย"
                aria-describedby="inputGroupPrepend"
                name="newadd"
                value={data.cur_address}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                จังหวัด
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="ระยอง"
                aria-describedby="inputGroupPrepend"
                name="newprovince"
                value={data.cur_province}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                ตำบล
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="เนินพระ"
                aria-describedby="inputGroupPrepend"
                name="newdist1"
                value={data.cur_sub_dis}
                disabled
                style={{
                  wborderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                อำเภอ
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="เมืองระยอง"
                aria-describedby="inputGroupPrepend"
                name="newdist2"
                value={data.cur_dis}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
              <Form.Label className="font-cen" style={{ fontSize: "28px" }}>
                รหัสไปรษณีย์
              </Form.Label>

              <Form.Control
                type="text"
                //placeholder="21000"
                aria-describedby="inputGroupPrepend"
                name="zip3"
                value={data.cur_poscode}
                disabled
                style={{
                  borderRadius: "10px",
                  height: "81px",
                  fontSize: "28px",
                }}
              />
            </Form.Group>
          </Row>
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              onClick={handleSend}
              //disabled
              id='senddata'
              className="custom-btn btnSave"
              style={{
                width: "258px",
                height: "90px",
                margin: "50px 100px 0px 0px",
                fontSize: "28px",
              }}
            >
              นำส่งข้อมูล
            </Button>
          </div>
          <div style={{ height: "100px" }} />

          <Modal
            show={checklist}
            onHide={handleClose}
            className="font-cen"
            centered
            size="lg"
            backdrop="static"
            keyboard={false}
            fullscreen={true}
          >
            
            <Modal.Body>
            <Modal.Title style={{ color: "red", textAlign:"center" }}>
                *** กรุณาอ่านเงื่อนไขและยอมรับเงื่อนไขก่อนการใช้งานค่ะ ***
                <br/>
                *** Please read condition before access system ***
              </Modal.Title>
              <Tabs
                activeKey={key}
                id="key"
                className="mb-3"
                onSelect={(k) => setKey(k)}
               
                //fill
                justtify
              >
                <Tab eventKey="1" title="1.เงื่อนไขก่อนทำการบิน During flight" >
                  <div>
                    <h4 style={{ textAlign: "center" }}>
                      เงื่อนไขการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน
                      <br />
                      (ออกตามมาตรา 24 แห่งพระราชบัญญัติการเดินอากาศ พ.ศ. 2497)
                    </h4>
                    &nbsp;
                    <div>
                      <h6>เงื่อนไขก่อนทำการบิน</h6>
                      <p>
                        1.
                        ให้ตรวจสอบว่าอากาศยานอยู่ในสภาพที่สามารถทำการบินได้อย่างปลอดภัย
                        ซึ่งรวมถึงตัวอากาศยานและระบบควบคุมอากาศยาน
                        <br />
                        2. ต้องได้รับอนุญาตจากเจ้าของพื้นที่ที่จะทำการบิน
                        <br />
                        3. ให้ทำการศึกษาพื้นที่และชั้นของห้วงอากาศที่จะทำการบิน
                        <br />
                        4. ต้องมีแผนฉุกเฉิน รวมถึงแผนสำหรับกรณีเกิดอุบัติเหตุ
                        การรักษาพยาบาล
                        และการแก้ปัญหากรณีไม่สามารถบังคับอากาศยานได้
                        <br />
                        5. ต้องมีการบำรุงรักษาตามคู่มือของผู้ผลิต
                        <br />
                        6.
                        ต้องมีความรู้ความชำนาญในการบังคับอากาศยานและระบบของอากาศยาน
                        <br />
                        7. ต้องมีความรู้ความเข้าใจในกฎจราจรทางอากาศ
                        <br />
                        8. ให้นำหนังสือการขึ้นทะเบียนผู้บังคับหรือปล่อยอากาศยาน
                        (ประเภทที่ควบคุมการบินจากภายนอก)
                        ติดตัวไว้ตลอดเวลาที่ทำการบิน
                        <br />
                        9.
                        ต้องมีอุปกรณ์ดับเพลิงที่สามารถใช้งานได้ติดตัวตลอดเวลาที่ทำการบิน
                        <br />
                        10.
                        ต้องมีการประกันภัยอากาศยานโดยรับผิดชอบต่อความเสียหายอันเกิดแก่ร่างกาย
                        ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สาม ในวงเงินไม่ต่ำกว่า 1
                        ล้านบาท/อุบัติเหตุ/ครั้ง
                        และกรมธรรม์ประกันภัยต้องอยู่ติดไปหนังสือการขึ้นทะเบียนผู้บังคับหรือปล่อยอากาศยาน
                        และต้องต่ออายุกรมธรรม์ล่วงหน้าก่อนวันสิ้นอายุไม่น้อยกว่า
                        30 วัน
                      </p>
                    </div>
                    <hr />
                    <div>
                      <h4 style={{ textAlign: "center" }}>
                        Annoucement of the Ministry of Transport On Rules to
                        Apply for Permission and Conditions to Control and
                        Launch Unmanned Aircraft in the Category of Remotely
                        Piloted Aircraft B.E. 2558 (A.D. 2015)
                      </h4>
                      <h6>Before flight</h6>
                      <p>
                        1. check that the Unmanned Aircraft and its
                        Remotely-piloted aircraft system is in a good condition
                        to fly;
                        <br />
                        2. get permission from the owner of the land to fly;
                        <br />
                        3. check the enviroment and airspace of the location to
                        fly;
                        <br />
                        4. have an emergency plan including plan for accident,
                        medical care and plan for problem solving case of
                        uncontrol the aircraft.
                        <br />
                        5. provide maintenance the Unmanned Aircarft according
                        to manufacture's manual;
                        <br />
                        6. has knowledge and skills in control of the Unmanned
                        Aircraft and its system;
                        <br />
                        7. has knowledge and understanding in the rule of the
                        air;
                        <br />
                        8. carry along with the certificate of registration or
                        its copy all the time of the flight;
                        <br />
                        9. carry along with a usable fire extinguisher all the
                        times of the flight; and
                        <br />
                        10. has an insurance policy, which covers damages caused
                        to the body, life and properties of the third parties,
                        and also the minimum sum insured is not less than one
                        million baht per time;
                      </p>
                    </div>
                    <div>
                      <Form.Group className="mb-3">
                        <Form.Check
                          required
                          label="รับทราบและยอมรับ/Accept"
                          feedback="You must agree before submitting."
                          feedbackType="invalid"
                          checked={agree1}
                          onClick={() => {
                            agree1 === false
                              ? setAgree1(!agree1) || setKey("2")
                              : setAgree1(!agree1) ||
                                setAgree2(!agree1) ||
                                setAgree3(!agree1);
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Tab>
                <Tab
                  disabled={!agree1}
                  eventKey="2"
                  title="2.เงื่อนไขระหว่างทำการบิน During flight"
              
                >
                  <div>
                    <h4 style={{ textAlign: "center" }}>
                      เงื่อนไขการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน
                      <br />
                      (ออกตามมาตรา 24 แห่งพระราชบัญญัติการเดินอากาศ พ.ศ. 2497)
                    </h4>
                    &nbsp;
                    <div>
                      <h6>เงื่อนไขระหว่างทำการบิน</h6>
                      <p>
                        1. ห้ามทำการบินในลักษณะที่อาจก่อให้เกิดอันตรายต่อชีวิต
                        ร่างกาย ทรัพย์สิน และรบกวนความสงบสุขของบุคคลอื่น
                        <br />
                        2. ห้ามทำการบินเข้าไปในบริเวณเขตหวงห้าม เขตกำกัด
                        และเขตอันตรายตามที่ประกาศในเอกสารแถลงข่าวการบินของประเทศไทย
                        (Aeronautical Information Publication – Thailand หรือ
                        AIP – Thailand) รวมทั้งสถานที่ราชการ หน่วยงานของรัฐ
                        โรงพยาบาล เว้นแต่จะได้รับอนุญาตจากหน่วยงานเจ้าของพื้นที่
                        <br />
                        3. แนวการบินขึ้นลงของอากาศยานจะต้องไม่มีสิ่งกีดขวาง
                        <br />
                        4.ผู้บังคับหรือปล่อยอากาศยานต้องสามารถมองเห็นอากาศยานได้ตลอดเวลาที่ทำการบินและห้ามทำการบังคับอากาศยานโดยอาศัย
                        ชุดกล้องบนอากาศยานหรืออุปกรณ์อื่นที่มีลักษณะใกล้เคียง
                        <br />
                        5.
                        ต้องทำการบินในระหว่างเวลาพระอาทิตย์ขึ้นถึงพระอาทิตย์ตก
                        ซึ่งสามารถมองเห็นอากาศยานได้อย่างชัดเจน
                        <br />
                        6. ห้ามทำการบินเข้าใกล้หรือเข้าไปในเมฆ
                        <br />
                        7. ห้ามทำการบินภายในระยะ 9 กิโลเมตร (5 ไมล์ทะเล)
                        จากสนามบินหรือที่ขึ้นลงชั่วคราวของอากาศยาน
                        เว้นแต่ได้รับอนุญาตจาก
                        เจ้าของหรือผู้ดำเนินการสนามบินอนุญาตหรือที่ขึ้นลงชั่วคราวอนุญาต
                        <br />
                        8. ห้ามทำการบินโดยใช้ความสูงเกิน 90 เมตร (300 ฟุต)
                        เหนือพื้นดิน
                        <br />
                        9. ห้ามทำการบินเหนือเมือง หมู่บ้าน ชุมชน
                        หรือพื้นที่ที่มีคนมาชุมนุมอยู่
                        <br />
                        10. ห้ามบังคับอากาศยานเข้าใกล้อากาศยานซึ่งมีนักบิน
                        <br />
                        11. ห้ามทำการบินละเมิดสิทธิส่วนบุคคลของผู้อื่น
                        <br />
                        12. ห้ามทำการบินโดยก่อให้เกิดความเดือดร้อน
                        ความรำคาญแก่ผู้อื่น
                        <br />
                        13.
                        ห้ามส่งหรือพาวัตถุอันตรายตามที่กำหนดในกฎกระทรวงหรืออุปกรณ์ปล่อยแสงเลเซอร์ติดไปกับอากาศยาน
                        <br />
                        14. ห้ามทำการบินโดยมีระยะห่างในแนวราบกับบุคคล ยานพาหนะ
                        สิ่งก่อสร้าง อาคาร
                        ที่ไม่เกี่ยวข้องกับการปฏิบัติการบินน้อยกว่า 50 เมตร (150
                        ฟุต)
                        <br />
                        15.เมื่อมีอุบัติเหตุเกิดขึ้นแก่อากาศยานให้ผู้บังคับหรือปล่อยอากาศยานแจ้งอุบัติเหตุนั้นต่อพนักงานเจ้าหน้าที่โดยไม่ชักช้า
                        (ในเวลาราชการ โทร 02 568 8800 ต่อ 1504, 1505 โทรสาร 02
                        568 8848 นอกเวลาราชการ 081 839 2068 หรือ email :
                        uav@caat.or.th)
                      </p>
                    </div>
                    <hr />
                    <div>
                      <h4 style={{ textAlign: "center" }}>
                        Annoucement of the Ministry of Transport On Rules to
                        Apply for Permission and Conditions to Control and
                        Launch Unmanned Aircraft in the Category of Remotely
                        Piloted Aircraft B.E. 2558 (A.D. 2015)
                      </h4>
                      <h6>During flight</h6>
                      <p>
                        1. must not fly in a way that may cause harm to the
                        life, property and peace of others.
                        <br />
                        2. must not fly into restricted area, limited area and
                        dangerous area announced in Aeronautical Information
                        Publication - Thailand or AIP-Thailand and also at
                        government buildings and hospitals unless permission is
                        given.
                        <br />
                        3. take-off and landing area must not be obstructed by
                        anything.
                        <br />
                        4. must keep the Unmanned Aircraft in line-of-sight at
                        all times and not rely on the monitor or other devices.
                        <br />
                        5. must only fly between sunrise and sunset when the
                        Unmanned Aircraft can clearly be seen.
                        <br />
                        6. must not fly in or near clouds.
                        <br />
                        7. must not fly within 9 km (5 nautical miles) from
                        airport or temporary airfield unless having permission
                        from the airport or airfields operators.
                        <br />
                        8. must not fly over 90 metersabove the ground.
                        <br />
                        9. must not fly over cities, villages, communities or
                        areas where people are gathered.
                        <br />
                        10. must not fly near other aircraft that have pilots.
                        <br />
                        11. must not violate the privacy rights of others.
                        <br />
                        12. must not cause a nuisance to others.
                        <br />
                        13. must not deliver or carry dangerous items or lasers
                        on the Unmanned Aircraft.
                        <br />
                        14. must not fly horizontally closer than 50 meters (150
                        feet) to people, vehicles, constructions or buildings.
                        <br />
                        15.when there is any accident access, pilot or
                        controller must contract officer immediately (During
                        trading hour tel : 02-5688800 ext 1504,1505 Fax
                        02-5688848 After trading hour : Tel 081-8392068 or via
                        Email : uav@caat.or.th)
                      </p>
                    </div>
                    <div>
                      <Form.Group className="mb-3">
                        <Form.Check
                          required
                          label="รับทราบและยอมรับ/Accept"
                          feedback="You must agree before submitting."
                          feedbackType="invalid"
                          checked={agree2}
                          onClick={() => {
                            agree2 === false
                              ? setAgree2(!agree2) || setKey("3")
                              : setAgree2(!agree2);
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Tab>
                <Tab
                  disabled={!agree2}
                  eventKey="3"
                  title="3.ประกาศกระทรวงคมนาคม เรื่อง หลักเกณฑ์การขออนุญาตฯ Annoucement of the Ministry of Transport"
                  
               >
                  <div>
                    <h5>
                      <GrSend />
                      ประกาศกระทรวงคมนาคม เรื่อง
                      หลักเกณฑ์การขออนุญาตและเงื่อนไขในการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน
                      ประเภทอากาศยานซึ่งควบคุมการบินจากภายนอก พ.ศ. ๒๕๕๘
                    </h5>

                    <hr />
                    <div>
                      <button
                        onClick={() => {
                          saveAs(
                            file1,
                            "Announcement-of-the-Ministry-of-Transport-thai.pdf"
                          );
                        }}
                      >
                        <AiOutlineDownload /> ดาวน์โหลดเอกสาร (Thai Version)
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <h5>
                      <GrSend />
                      Annoucement of the Ministry of Transport On Rules to Apply
                      for Permission and Conditions to Control and Launch
                      Unmanned Aircraft in the Category of Remotely Piloted
                      Aircraft B.E. 2558 (A.D. 2015)
                    </h5>

                    <hr />
                    <div>
                      <button
                        onClick={() => {
                          saveAs(
                            file2,
                            "Announcement-of-the-Ministry-of-Transport.pdf"
                          );
                        }}
                      >
                        <AiOutlineDownload /> Download document (English
                        Version)
                      </button>
                    </div>
                    <hr />
                    <div>
                      <Form.Group className="mb-3">
                        <Form.Check
                          required
                          label="รับทราบและยอมรับ/Accept"
                          feedback="You must agree before submitting."
                          feedbackType="invalid"
                          checked={agree3}
                          onClick={() => setAgree3(!agree3)}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="custom-btn btnCancel"
                onClick={() => {
                  Navigate("/home");
                }}
              >
                ยกเลิก
              </Button>
              {agree3 === true && agree2 === true && agree1 === true ? (
                <Button className="custom-btn btnSave" onClick={handleUpdatesuc}>
                  ยืนยัน
                </Button>
              ) : null}
            </Modal.Footer>
          </Modal>
          <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
          <Modal
            show={updatedata}
            onHide={handleClose}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>บันทึกข้อมูล</Modal.Title>
            </Modal.Header>
            <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
            <Modal.Footer>
              <Button className="custom-btn btnCancel" onClick={handleClose}>
                ยกเลิก
              </Button>
              <Button className="custom-btn btnSave" onClick={handleUpdatesuc}>
                ยืนยัน
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={updatedatasuc}
            onHide={handleClose}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                src={check}
                style={{
                  width: "100px",
                  height: "100px",
                  padding: "3%",
                  marginLeft: "180px",
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                ยกเลิก
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={show} onHide={handleClose} className="font-cen" centered>
            <Modal.Header closeButton>
              <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ข้อมูลส่วนตัวจะถูกส่งข้อมูลการขอขึ้นทะเบียนนักบิน
            </Modal.Body>
            <Modal.Footer>
              <Button  className="custom-btn btnCancel" onClick={handleClose}>
                ยกเลิก
              </Button>
              <Button  className="custom-btn btnSave" onClick={handleSendsuc}>
                นำส่งข้อมูล
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={senddata}
            onHide={handleClose}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                src={check}
                style={{
                  width: "100px",
                  height: "100px",
                  padding: "3%",
                  marginLeft: "180px",
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={next}>
                ปิด
              </Button>
              {/* <Button variant="primary" onClick={handleClose}>
                ดูสถานะ
              </Button> */}
            </Modal.Footer>
          </Modal>
          <Modal
            show={checkuserdata}
            centered
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            className="font-cen"

            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //background: "black",
              }}
            >
              <h3>ไม่มีข้อมูลผู้ใช้</h3>
            </Modal.Body>
          </Modal>
          <Modal
            show={showErroroperation}
            onHide={() => setShowErroroperation(false)}
            aria-labelledby="contained-modal-title-vcenter"
            size="sm"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                ท่านได้เป็นนักบินแล้วแล้วค่ะ
              </div>
            </Modal.Body>
          </Modal>
        </Form>
      </div>
    </div>
  );
}

export default RegisPilotSpacific;
